export const addCommaEvery3Digits = (num) => {
  if (num instanceof String && !Number.isInteger(parseInt(num))) {
    throw new Error('num is not valid.');
  }
  if (!Number.isInteger(num)) {
    throw new Error('num is not valid.');
  }
  return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
};
